import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const Target = ( { size, color }) =>
{
    return (
        <svg width={size} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
             viewBox="0 0 20 20">
            <g>
                <path d="M10.1,1C5.5,1,1.8,4.7,1.8,9.3s3.7,8.3,8.3,8.3s8.3-3.7,8.3-8.3S14.7,1,10.1,1z M10.1,16.7c-4.1,0-7.4-3.3-7.4-7.4
    s3.3-7.4,7.4-7.4s7.4,3.3,7.4,7.4S14.2,16.7,10.1,16.7z" fill={color}/>
                <path d="M10.1,2.8c-3.6,0-6.5,2.9-6.5,6.5s2.9,6.5,6.5,6.5s6.5-2.9,6.5-6.5S13.7,2.8,10.1,2.8z M10.1,14.8c-3.1,0-5.5-2.5-5.5-5.5
    s2.5-5.5,5.5-5.5s5.5,2.5,5.5,5.5S13.2,14.8,10.1,14.8z" fill={color}/>
                <path d="M14.7,9.3c0,2.5-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6S14.7,6.8,14.7,9.3" fill={color}/>
            </g>
        </svg>
    )
}

export default Target ;

Target.propTypes = {
    type: PropTypes.string
};

